<template>
  <div class="toggle-switch" :class="[ block ? `block` : `inline` ]">
    <span class="toggle-switch-label" :class="{
      active: value === false,
    }">
      {{ leftLabel }}
    </span>
    <toggle-button class="toggle-switch-toggle" :class="{ active : value === true }"
                   :value="value"
                   :sync="true"
                   @change="$emit(`change`, $event.value)" />
    <span class="toggle-switch-label" :class="{
      active: value === true,
    }">
      {{ rightLabel }}
    </span>
  </div>
</template>

<script>
import { ToggleButton } from 'vue-js-toggle-button';

export default {
  components: {
    ToggleButton,
  },
  model: {
    prop: `value`,
    event: `change`,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    block: {
      type: Boolean,
      required: false,
      default: true,
    },
    leftLabel: {
      type: String,
      required: true,
    },
    rightLabel: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@use "AssetsSass/_variables" as *;

.toggle-switch {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;

  :deep(&.active) {
    .v-switch-core {
      background-color: map.get($ss, 'primary') !important;
    }
  }

  .toggle-switch-label {
    &.active {
      font-weight: bold;
      color: map.get($ss-theme, 'hunter-grey');
    }
  }

  &.inline {
    display: inline;
    .toggle-switch-toggle {
      margin: auto 12px;
    }
  }
}
</style>
